/** @format */

import { api } from 'utility';
import { getCRDUploadedDocsListUrl, getDocumentTypesUrl } from 'URLs';

export function getDocumentsService() {
  return api.get(getCRDUploadedDocsListUrl()).then((res) => res.data);
}

export function getDocumentTypes() {
  return api.get(getDocumentTypesUrl()).then((res) => res.data);
}

export async function deleteDocService(data) {
  return api.delete(getCRDUploadedDocsListUrl(), { data });
}
